import {
  LuBriefcase,
  LuCar,
  LuChartLine,
  LuClapperboard,
  LuCreditCard,
  LuGraduationCap,
  LuHeartPulse,
  LuHouse,
  LuKeyRound,
  LuLandmark,
  LuMonitorSmartphone,
  LuPawPrint,
  LuPlane,
  LuShirt,
  LuShoppingBag,
  LuSparkles,
  LuTrophy,
  LuUsers,
  LuWheat
} from 'react-icons/lu'

/**
 * Maps INTEREST_CATEGORIES' `icon` string (kebab-case) to its Lucide
 * component. Names/mapping taken from the prototype
 * (github.com/vtex/ads-design-prototypes, feat/offsite,
 * apps/offsite/v2.html — DV360_INTEREST_CATEGORIES) for visual parity.
 * `line-chart` maps to `LuChartLine`: lucide renamed that icon after the
 * prototype was written, but `react-icons/lu` only ships the current name.
 */
export const CATEGORY_ICON_BY_NAME: Record<string, React.ComponentType> = {
  wheat: LuWheat,
  car: LuCar,
  'graduation-cap': LuGraduationCap,
  'heart-pulse': LuHeartPulse,
  sparkles: LuSparkles,
  shirt: LuShirt,
  house: LuHouse,
  'key-round': LuKeyRound,
  'credit-card': LuCreditCard,
  briefcase: LuBriefcase,
  'monitor-smartphone': LuMonitorSmartphone,
  plane: LuPlane,
  trophy: LuTrophy,
  clapperboard: LuClapperboard,
  users: LuUsers,
  'paw-print': LuPawPrint,
  'shopping-bag': LuShoppingBag,
  landmark: LuLandmark,
  'line-chart': LuChartLine
}
